import React, { useContext } from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import { Link, useParams } from 'react-router-dom'
import { initiativeUrl } from 'config/constants/urls'
import EventListItemCard from 'src/apps/Events/components/ListItemCard'
import ResourceListItemCard from 'src/apps/Resources/components/ListItemCard'
import { arrayToSentenceFragment } from 'src/components/utils'
import { useInitiativeList, useOrganization } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'

const GroupRelatedInitiatives = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)
   const theme = useContext(ThemeContext)

   const { organization } = useOrganization()
   const { relatedClass } = useParams()
   const initiativeTypes = organization.initiativeTypes
      .filter(t => t.enabled && t.class === relatedClass)

   const initiativeTypeIds = initiativeTypes.map(t => t.id)
   const initiativeTypeNames = initiativeTypes.map(t => t.namePlural)

   const { initiativeList } = useInitiativeList({
      relatedToInitiativeId: initiative.id,
      typeIds: initiativeTypeIds
   })

   return (
      <>
         <View
            display="flex"
            alignItems="center"
            width="100%"
            height="60px[a-d] 80px[e-f]"
            marginBottom="20px"
            borderBottom={`1px solid ${theme.tmpContentLineColor}`}>
            <Text
               color={theme.tmpContentTitleColor}
               size="6">
               {`Related ${arrayToSentenceFragment(initiativeTypeNames)}`}
            </Text>
         </View>
         <View
            display="flex"
            flexFlow="column"
            justifyContent="flex-start"
            position="absolute"
            top="90px"
            left="0px"
            right="0px"
            bottom="0px">
            <View
               padding="20px 30px"
               scroll="on">
               {initiativeList.items.length === 0 && (
                  <View>
                     <Text size="2" color="#aaa">No items to show</Text>
                  </View>
               )}
               <Grid columns="4">
                  {initiativeList.items.map((relatedInitiative) => {
                     if (relatedInitiative.class === 'resource') {
                        return (
                           <GridCell key={relatedInitiative.id}>
                              <ResourceListItemCard
                                 dateAdded={relatedInitiative.dateAdded}
                                 linkTo={initiativeUrl(relatedInitiative)}
                                 logoIcon={relatedInitiative.logoIcon?.file.thumbnailUrlW120}
                                 name={relatedInitiative.name}
                                 subtitle={relatedInitiative.subtitle}
                                 summary={relatedInitiative.body.summary}
                                 textColor={theme.tmpContentTextColor}
                              />
                           </GridCell>
                        )
                     }

                     if (relatedInitiative.class === 'event') {
                        return (
                           <GridCell key={relatedInitiative.id}>
                              <EventListItemCard
                                 coverMedia={relatedInitiative.coverMedia}
                                 date={relatedInitiative.startDateTimeISO8601}
                                 linkTo={initiativeUrl(relatedInitiative)}
                                 name={relatedInitiative.name}
                                 subtitle={relatedInitiative.subtitle}
                                 summary={relatedInitiative.body.summary}
                                 textColor={theme.tmpContentTextColor}
                                 virtual={relatedInitiative.eventIsVirtual}
                              />
                           </GridCell>
                        )
                     }

                     return (
                        <Link
                           key={relatedInitiative.id}
                           to={initiativeUrl(relatedInitiative)}>
                           <Text>{relatedInitiative.name}</Text>
                        </Link>
                     )
                  })}
               </Grid>
            </View>
         </View>
      </>
   )
}

export default GroupRelatedInitiatives
